/*
  Asset-CDN config for the shared package.

  The CDN host is fixed — it's our S3 bucket and it doesn't move — so only the
  game folder is configurable. Shared can't read import.meta.env (Metro doesn't
  support it), so the host app injects the slug at bootstrap, same idiom as
  configureApi. The default matches today's value, so an un-configured host
  behaves exactly as before.
*/
const ASSETS_BASE_URL = "https://assets.easysbc.io";
let gameSlug = "fc27";
export const configureAssets = (config) => {
    if (config.gameSlug)
        gameSlug = config.gameSlug;
};
/** Asset under the current game's folder, e.g. "sbcs/sets/icons/12.png". */
export const gameAssetUrl = (path) => `${ASSETS_BASE_URL}/${gameSlug}/${path.replace(/^\//, "")}`;
//# sourceMappingURL=assets.js.map